import React from "react";
import { Avatar, Box } from "@mui/material";

const UserImages = ({ images = [], sx = {}, ...props }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }} {...props}>
    {images.map((src, idx) => (
      <Avatar key={idx} src={src} />
    ))}
  </Box>
);

export default UserImages;
